import { useLiveResource } from "@lib/hooks/useLiveResource";

export function useOutreachListChannel(onUpdate: () => void) {
  useLiveResource({
    channel: "OutreachListChannel",
    onInvalidate: onUpdate,
  });
}
